import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, BadgeCheck } from "lucide-react";

const SHOTS = [
  "/assets/result-1.png",
  "/assets/result-2.png",
  "/assets/result-3.png",
  "/assets/result-4.png",
  "/assets/result-5.png",
];
const CAPTIONS = [
  "Letzte 7 Tage · 38.905 € GMV · 957 Verkäufe · 5.020 € Provision",
  "Letzte 7 Tage · 26.458 € GMV · 4.230,9 € Provision",
  "Letzte 7 Tage · 25.001 € GMV · 983 Verkäufe · 3.869,8 € Provision",
  "Creator-Dashboard · 14,7K € GMV · 4,7M Produktaufrufe",
  "Schlüsseldaten · 2,9K € GMV · 667,62 € Provision · +17 %",
];

export default function ResultsSlider() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % SHOTS.length), 4500);
    return () => clearInterval(t);
  }, []);
  return (
    <section className="relative py-16 border-y border-white/10 bg-[#070707]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-8">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#00F2FE]/10 border border-[#00F2FE]/30 text-[#00F2FE] text-xs font-mono uppercase tracking-wider mb-3">
            <BadgeCheck className="h-3 w-3" /> Echte Ergebnisse · Creator-Dashboards
          </span>
          <h3 className="font-display font-black tracking-tighter text-3xl md:text-4xl">Das schaffen unsere Creator.</h3>
        </div>
        <div className="relative rounded-2xl border border-white/10 bg-[#0A0A0A] overflow-hidden">
          <div className="relative aspect-[16/9] md:aspect-[16/8] bg-white">
            {SHOTS.map((src, idx) => (
              <img
                key={src}
                src={src}
                alt={CAPTIONS[idx]}
                className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ${i === idx ? "opacity-100" : "opacity-0"}`}
                data-testid={`results-slide-${idx}`}
              />
            ))}
          </div>
          <button
            data-testid="slider-prev"
            onClick={() => setI((x) => (x - 1 + SHOTS.length) % SHOTS.length)}
            className="absolute left-3 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-black/70 border border-white/10 hover:bg-[#FF0050] text-white flex items-center justify-center"
            aria-label="Previous"
          ><ChevronLeft className="h-5 w-5" /></button>
          <button
            data-testid="slider-next"
            onClick={() => setI((x) => (x + 1) % SHOTS.length)}
            className="absolute right-3 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-black/70 border border-white/10 hover:bg-[#FF0050] text-white flex items-center justify-center"
            aria-label="Next"
          ><ChevronRight className="h-5 w-5" /></button>
        </div>
        <div className="flex items-center justify-between gap-4 mt-4">
          <p className="text-zinc-400 text-sm">{CAPTIONS[i]}</p>
          <div className="flex gap-1.5">
            {SHOTS.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                data-testid={`slider-dot-${idx}`}
                className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-[#FF0050]" : "w-3 bg-white/20 hover:bg-white/40"}`}
                aria-label={`Slide ${idx + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
